import { ROUTES } from '@/core/config/routing'
import { ActionPlanMessage } from './actionPlanConfig.types'

export const actionPlanMessages: ActionPlanMessage[] = [
    {
        type: 'security-alert',
        title: 'SECURITY ALERT! Suspected user mailbox takeover detected',
        callToAction:
            'You may be experiencing a cyber attack. Please take immediate action.',
        priority: 100,
        id: 'suspected-ato',
        redirection: {
            type: 'internal',
            value: ROUTES.fraud_defense.children.open_issues.path,
        },
    },
    {
        type: 'security-alert',
        title: 'SECURITY ALERT! Suspicious incoming email detected',
        callToAction:
            'You may be experiencing a cyber attack. Please take immediate action.',
        priority: 90,
        id: 'suspected-incoming-email',
        redirection: {
            type: 'internal',
            value: ROUTES.fraud_defense.children.open_issues.path,
        },
    },
    {
        type: 'critical-issues',
        title: 'Critical Vulnerabilities Detected',
        callToAction:
            'Please address these issues urgently to prevent attackers from compromising your organization.',
        priority: 80,
        id: 'critical-issues',
        redirection: {
            type: 'internal',
            value: ROUTES.summary.path,
            scrollTo: 'security-issues-table',
        },
    },
    {
        type: 'important-action',
        title: 'Activate Fraud Defense and Security Monitoring',
        callToAction:
            'Connect your cloud apps to enable fraud protection and security monitoring.',
        priority: 70,
        id: 'activate-integrations',
        redirection: {
            type: 'internal',
            value: ROUTES.integrations.path,
        },
    },
    {
        type: 'important-action',
        title: 'Update required to activate Fraud Defense',
        callToAction:
            'Update cloud integrations to unlock additional Fraud Defense services.',
        priority: 65,
        id: 'update-integration-required',
        redirection: {
            type: 'internal',
            value: ROUTES.fraud_defense.children.open_issues.path,
        },
    },
    {
        type: 'important-action',
        title: 'Enable Fraud Defense',
        callToAction:
            'Enable Fraud Defense to start monitoring your emails for fraud attempts.',
        priority: 60,
        id: 'enable-fraud-defense',
        redirection: {
            type: 'internal',
            value: ROUTES.fraud_defense.children.configurations.path,
        },
    },
    {
        type: 'mdr',
        title: 'MDR Services Not Active',
        callToAction:
            'Register for 24x7 monitoring and incident response from At-Bay’s expert MDR team.',
        priority: 50,
        id: 'mdr-not-active',
        redirection: {
            type: 'internal',
            value: ROUTES.mdr.path,
        },
    },
    {
        type: 'low-priority-issues',
        title: 'Security issues found in your network',
        callToAction:
            'Resolve these issues to strengthen your security posture.',
        priority: 30,
        id: 'low-priority-issues',
        redirection: {
            type: 'internal',
            value: ROUTES.summary.path,
            scrollTo: 'security-issues-table',
        },
    },
    {
        type: 'low-priority-action',
        title: 'Security training service not activated',
        callToAction:
            "Enable employee training to reduce your organization's vulnerability to cyber attacks.",
        priority: 20,
        id: 'security-training',
        redirection: {
            type: 'internal',
            value: ROUTES.settings.children.user.path,
        },
    },
    {
        type: 'general',
        title: 'Review latest Stance version release notes',
        callToAction:
            'Discover the latest feature releases and improvements in your Stance platform.',
        priority: 5,
        id: 'release-notes',
        redirection: {
            type: 'external',
            value: 'https://knowledge.at-bay.com/release-notes/stance-release-notes/',
        },
    },
    {
        type: 'general',
        title: 'Review latest Patch Tuesday recommendations',
        callToAction: 'Discover the latest Microsoft security updates.',
        priority: 4,
        id: 'patch-tuesday',
        redirection: {
            type: 'external',
            value: 'https://knowledge.at-bay.com/patch-tuesday/',
        },
    },
]
